import BaseComponent from "../../baseComponent.js";
import EditableRow from "./editableRow.jsx";

export default class Output extends BaseComponent {
  handleDrop(e) {
    let data = JSON.parse(e.dataTransfer.getData('data'));
    this.props.handleOutputDrop(data);
  }

  preventDefault(e) {
    e.preventDefault();
  }

  render() {
    let output = this.props.datasetOutputModel;
    let fieldIds = Object.keys(this.props.datasetOutputModel.fields);
    let rows = [];

    for (let i = 0; i < this.props.numRows; i++) {
      let fieldId = fieldIds[i] || "";
      let value = fieldId != "" ? output.fields[fieldId].value : "";
      let formula = fieldId != "" ? output.fields[fieldId].formula : "";
      rows.push(<EditableRow
        type="OUTPUT"
        onClick={this.props.changeCurrentFormula}
        onChange={this.props.updateFormula}
        createMapping={this.props.createMapping}
        datasetId={output.datasetId}
        datasetRefId={output.datasetRef}
        fieldId={fieldId}
        color={output.color}
        value={value}
        formula={formula}
        key={i}
      />);
    }
    return (
      <div className="spreadsheet-output-dataset"
           onDragOver={this.preventDefault}
           onDrop={this.handleDrop}>
        <table ref="table">
          <tbody>
          {rows}
          </tbody>
        </table>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/analytic-studio/spreadsheet/output.jsx